import React, { useState, useEffect } from "react";

import { trackPromise } from "react-promise-tracker";

import services from "../../services";

import { detalhesPasta, editarPasta } from "../../services/http/pastaService";
import {
  registrarDownloadPasta,
  registrarVisualizacaoPasta,
} from "../../services/http/dashboardService";

import { listarPermissoes } from "../../services/http/usuariosService";

import { Modal, Checkbox, message, Radio } from "antd";

import infoPastaSvg from "../../assets/icons/infoPasta.svg";

import "./styles.scss";
import ModalConfirmar from "../ModalConfirmar";
import { CloseOutlined } from "@mui/icons-material";
import lang from "../../assets/idioma/idiomas";

const ModalEditarPasta = ({
  id,
  tipo,
  closeModal,
  openModal,
  buscar,
  onLoadData,
  setInfoPastaEditada,
}) => {
  const { IdUser, IsAdmin } = services.storage.getUser();
  const [permissoes, setPermissoes] = useState([]);
  const [pastaPermissoes, setPastaPermissoes] = useState([{}]);
  const [nomePasta, setNomePasta] = useState("");
  const [pemissoesPasta, setPermissoesPasta] = useState([{}]);
  const [dataVencimentoInicial, setDataVencimentoInicial] = useState("");
  const [dataVencimentoFinal, setDataVencimentoFinal] = useState("");
  const [horaInicial, setHoraInicial] = useState("");
  const [horaFinal, setHoraFinal] = useState("");
  const [pasta, setPasta] = useState({});
  const [segundoModal, setSegundoModal] = useState(false);
  const [checkAntes, setCheckAntes] = useState([]);
  const [checkDepois, setCheckDepois] = useState([]);
  const [modificar, setModificar] = useState(false);
  const [incluirSubPastasArquivosCheck, setIncluirSubPastasArquivosCheck] =
    useState(false);
  useEffect(() => {
    buscarDetalhes();
  }, [id]);

  useEffect(() => {
    montarPermissoes();
  }, [permissoes]);

  const listaPermissoes = () => {
    trackPromise(
      listarPermissoes(true)
        .then((res) => {
          if (!res.fail && res.data) {
            setPermissoes(res.data);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const registrarVisualizacaoPastas = (idPasta) => {
    trackPromise(
      registrarVisualizacaoPasta(idPasta)
        .then((res) => {
          if (!res.fail) {
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const buscarDetalhes = () => {
    trackPromise(
      detalhesPasta(id)
        .then((res) => {
          if (!res.fail) {
            setNomePasta(res.data.nome);

            if (res.data.dataVencimentoInicial) {
              let date1 = new Date(
                res.data.dataVencimentoInicial
              ).toLocaleDateString("fr-CA");
              setDataVencimentoInicial(date1);
              var hora1 = res.data.dataVencimentoInicial.substring(11, 16);
              setHoraInicial(hora1);
            }

            if (res.data.dataVencimentoFinal) {
              let date2 = new Date(
                res.data.dataVencimentoFinal
              ).toLocaleDateString("fr-CA");
              setDataVencimentoFinal(date2);
              var hora2 = res.data.dataVencimentoFinal.substring(11, 16);
              setHoraFinal(hora2);
            }
            registrarVisualizacaoPastas(id);
            setPasta(res.data);
          }
        })
        .finally(() => {
          listaPermissoes();
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const montarPermissoes = () => {
    setPermissoesPasta([{}]);
    let novaListaPemissoes = [];

    if (pasta.permissoes) {
      permissoes?.forEach((element) => {
        let permissao = pasta.permissoes.findIndex((p) => p.id == element.id);

        novaListaPemissoes.push({
          id: element.id,
          permissao: element.permissao,
          checked: permissao >= 0 ? true : false,
        });
      });
      setPermissoesPasta(novaListaPemissoes);
      // Cria uma cópia profunda para checkAntes e checkDepois terem a mesma estrutura inicial
      setCheckAntes(novaListaPemissoes.map((p) => ({ ...p })));
      setCheckDepois(novaListaPemissoes.map((p) => ({ ...p })));
    } else {
      setPermissoesPasta(permissoes);
    }
  };

  const editar = (idUsuarioOcultou) => {
    if (nomePasta.length > 0) {
      let arrayPermissoes = [];
      pemissoesPasta.forEach((element) => {
        if (element.checked) {
          arrayPermissoes.push({
            id: element.id,
            permissao: element.permissao,
          });
        }
      });

      let data = {
        nomePasta: nomePasta,
        idPasta: id,
        idUsuarioOcultou: idUsuarioOcultou ? IdUser : null,
        permissoes: arrayPermissoes,
        dataVencimentoInicial: dataVencimentoInicial + " " + horaInicial,
        dataVencimentoFinal: dataVencimentoFinal + " " + horaFinal,
        incluirSubPastasArquivos: incluirSubPastasArquivosCheck,
      };

      if (dataVencimentoInicial == "" && horaInicial != "") {
        message.warning(lang.Informar_a_data_inicial);
        return;
      }

      if (dataVencimentoFinal == "" && horaFinal != "") {
        message.warning(lang.Informar_a_data_final);
        return;
      }

      if (data.dataVencimentoInicial === " ") {
        data.dataVencimentoInicial = null;
      }
      if (data.dataVencimentoFinal === " ") {
        data.dataVencimentoFinal = null;
      }

      if (
        data.dataVencimentoInicial !== null &&
        data.dataVencimentoFinal !== null
      ) {
        if (data.dataVencimentoFinal < data.dataVencimentoInicial) {
          message.warning(
            lang.A_data_inicial_nao_pode_ser_maior_que_a_data_final
          );
          return;
        }
      }

      if (
        data.dataVencimentoInicial === null &&
        data.dataVencimentoFinal !== null
      ) {
        message.warning(lang.Informar_a_data_inicial);
        return;
      }

      trackPromise(
        editarPasta(data)
          .then((res) => {
            if (!res.fail) {
              message.success(lang.Pasta_alterada_com_sucesso);
              buscar(nomePasta, 1);
              closeModal();

              let params = {
                key: "0",
                children: null,
              };
              onLoadData(params);
              setInfoPastaEditada({ nomePasta: nomePasta, idPasta: id });
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    } else {
      message.warning(lang.Preencha_o_nome_da_pasta);
      return;
    }
  };

  const handleCheckedPermissoes = (item, checked) => {
    if (item == "todos") {
      var arrayMap = pemissoesPasta.map((p) => {
        return {
          id: p.id,
          permissao: p.permissao,
          checked: checked,
        };
      });
      setPermissoesPasta(arrayMap);
      setCheckDepois(arrayMap);
    } else {
      let indexPermissao = pemissoesPasta.findIndex((p) => p.id == item);

      if (indexPermissao >= 0) {
        const novaLista = pemissoesPasta.map((p, idx) =>
          idx === indexPermissao ? { ...p, checked: checked } : { ...p }
        );
        setPermissoesPasta(novaLista);
        setCheckDepois(novaLista);
      }
    }
  };
  useEffect(() => {
    if (modificar) {
      editar(null);
    }
  }, [modificar]);

  function valorIncuirSubPastas(e) {
    setIncluirSubPastasArquivosCheck(e.target.value);
  }
  const formatNomePasta = (nome) => {
    if (nome.length > 20) {
      return nome.slice(0, 20) + "...";
    }
    return nome;
  };
  return (
    <div>
      <Modal
        title={
          <span className="modal-title-editar-pasta ">{lang.Editar_pasta}</span>
        }
        visible={openModal}
        className="modal-editar-pasta"
        closable={false}
        destroyOnClose={true}
        footer={[]}
      >
        <CloseOutlined onClick={closeModal} className="custom-close-icon" />
        <>
          <div className="row mt-5">
            <div className="col-md-5 p-0">
              <div className="editar-pasta-info-icone mt-5 ">
                <img src={infoPastaSvg} />
              </div>
            </div>
            <div className="editar-pasta-container-info col-md-7">
              <div className="editar-pasta-container-pasta ">
                <div className="editar-pasta-label-input">
                  <label>{lang.Nome}</label>
                  <input
                    onChange={(e) => setNomePasta(e.target.value)}
                    value={nomePasta}
                  />
                </div>

                <div className="editar-pasta-info-group-info">
                  <div className="row">
                    <div
                      className="col-md-8 col-sm-8 col-xl-8 itensPastasText mt-4 p-0"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {lang.Aplicar_alterações_em_sub_pastas_e_arquivos}:
                    </div>
                    <div className="col-md-4 col-sm-4 col-xl-4 mt-4">
                      <Radio.Group
                        onChange={valorIncuirSubPastas}
                        value={incluirSubPastasArquivosCheck}
                      >
                        <Radio value={true}>{lang.Sim}</Radio>
                        <Radio value={false}>{lang.Nao}</Radio>
                      </Radio.Group>
                    </div>
                  </div>

                  <div className="row mt-5">
                    <span className="editar-pasta-span-title mt-4">
                      {lang.Permissoes}
                    </span>
                  </div>

                  <div
                    className="editar-pasta-listagem-permissoes"
                    style={{ marginTop: "1rem" }}
                  >
                    {pemissoesPasta.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="editar-pasta-usuario-permissoes"
                        >
                          <Checkbox
                            defaultChecked={item.checked}
                            onChange={(e) =>
                              handleCheckedPermissoes(
                                `${item.id}`,
                                e.target.checked
                              )
                            }
                          >
                            {item.permissao}
                          </Checkbox>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
            <hr className="editar-pasta-linha" />
            <div>
              <div className="group-data-hora-pasta  d-flex justify-content-center w-100">
                <div className="label-input d-flex justify-content-center w-100">
                  <div className="row w-100">
                    <div className="col-md-3">
                      <label className="mb-0">Data início</label>
                      <input
                        disabled={IsAdmin.toLocaleLowerCase() != "true"}
                        className="input-data-arquivo w-100"
                        type="date"
                        onChange={(e) =>
                          setDataVencimentoInicial(e.target.value)
                        }
                        value={dataVencimentoInicial}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="mb-0">Hora início</label>
                      <input
                        disabled={IsAdmin.toLocaleLowerCase() != "true"}
                        className="input-hora-arquivo w-100"
                        type="time"
                        onChange={(e) => setHoraInicial(e.target.value)}
                        value={horaInicial}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="mb-0">Data fim</label>
                      <input
                        disabled={IsAdmin.toLocaleLowerCase() != "true"}
                        className="input-data-arquivo w-100"
                        type="date"
                        onChange={(e) => setDataVencimentoFinal(e.target.value)}
                        value={dataVencimentoFinal}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="mb-0">Hora fim</label>
                      <input
                        disabled={IsAdmin.toLocaleLowerCase() != "true"}
                        className="input-hora-arquivo w-100"
                        type="time"
                        onChange={(e) => setHoraFinal(e.target.value)}
                        value={horaFinal}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className="editar-pasta-buttons-finalizar-editar mt-5">
              <div className="editar-pasta-buttons-publicar ">
                <button
                  onClick={closeModal}
                  className="editar-pasta-button-publicar-mim-novo"
                >
                  {lang.Cancelar}
                </button>

                <button
                  className="editar-pasta-button-publicar-todos-novo"
                  onClick={() => setSegundoModal(true)}
                >
                  {lang.Salvar}
                </button>
              </div>
            </div>
          </div>
        </>
      </Modal>

      {segundoModal && (
        <ModalConfirmar
          segundoModal={segundoModal}
          setSegundoModal={setSegundoModal}
          checkAntes={checkAntes}
          checkDepois={checkDepois}
          setModificar={setModificar}
        />
      )}
    </div>
  );
};

export default ModalEditarPasta;
